/* ================================================== */
/* LOGIN → panel
/* ================================================== */

$(document).ready(function() {

	// Init
	var previousLink   = $('header .on')[0],
		$loginLink     = null,
		loginPanelOpen = false;

	// Functions
	function openLoginPanel(trigger) {
		$('body').addClass('login-panel noscroll');
		previousLink = $('header .on')[0];
		if ($(previousLink).length) $(previousLink).removeClass('on');
		$loginLink   = trigger;
		$('.on').removeClass('on');
		$('.btn-login').addClass('on');
		loginPanelOpen = true;
	}

	function closeLoginPanel() {
		$('body').removeClass('login-panel noscroll');
		if ($(previousLink).length) $(previousLink).addClass('on');
		if ($loginLink !== null && $loginLink.length) $loginLink.removeClass('on');
		loginPanelOpen = false;
	}

	// Trigger events
	$('.btn-login').click(function() {
		if (loginPanelOpen === true) {
			closeLoginPanel();
		} else {
			openLoginPanel($(this));
		}
	});

	// Close → menu links
	$('header a:not(.btn-login):not(.instagram)').click(function(event) {
		event.preventDefault();

		// If back to same page or a filtered view
		if (loginPanelOpen === true
			&& (typeof $(this).attr('href') === 'undefined' || $(this).attr('href') == $(previousLink).attr('href'))) {

			// Close login panel
			closeLoginPanel();

			// Update filtered view class
			if (typeof $(previousLink).attr('href') === 'undefined') {
				$('.on').removeClass('on');
				$(this).addClass('on');
			}

		// If go to another page
		} else if (typeof $(this).attr('href') !== 'undefined') {
			window.location.href = $(this).attr('href'); 
		}

	});

	// Close → mobile icon
	$('#login-panel .close').click(function(event) {
		event.preventDefault();
		closeLoginPanel();
	});

	// Close → esc key
	$(document).keyup(function(e) {
		if (e.keyCode == 27) closeLoginPanel()
	});

});